<lib-page-layout>
  <lib-title-navbar pageHeader title="Ustawienia powiadomień"></lib-title-navbar>

  <div class="or-mx-20-px or-mt-16-px">
    @for (category of preferences(); track category.category) {
      <div class="or-d-flex or-align-items-center or-justify-content-between or-py-12-px">
        <div class="or-mr-16-px or-flex-1">
          <div class="or-head-md or-mb-2-px">{{ category.label }}</div>
          <div class="or-note-sm or-color-secondary-2">{{ category.description }}</div>
          @if (!category.editable) {
            <div class="or-note-sm or-color-secondary-2 or-mt-4-px">Zawsze włączone</div>
          }
        </div>
        <ion-toggle [checked]="category.enabled" [disabled]="!category.editable" (ionChange)="toggle(category, $event)">
        </ion-toggle>
      </div>
      <div class="custom-divider or-w-100-pc"></div>
    }
  </div>
</lib-page-layout>
